module.exports = __webpack_public_path__ + "static/img/h2-1.28a1429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h2-1.png
// module id = P6mH
// module chunks = 1